module.exports = __webpack_public_path__ + "static/media/policeCar_white.d9ebd4cf.svg";